import { useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";

type ParamsType = { tab: string };

const useRedirectToDetails = (tab = "") => {
	const history = useHistory();
	const params = useParams<ParamsType>();

	return useCallback(
		(id: string, redirectedTab?: string) => {
			params.tab = redirectedTab || tab || params.tab;
			const detailsPage = `${params.tab}/${id}/details`;
			history.push(detailsPage);
		},
		[history, params, tab],
	);
};

export default useRedirectToDetails;
